import { isArray } from 'lodash';

import type { Model, Slicer } from '../../types';

export enum Size {
  EXTRA_EXTRA_LARGE = 'xxl',
  EXTRA_LARGE = 'xl',
  EXTRA_SMALL = 'xs',
  FLEX = 'flex',
  LARGE = 'lg',
  MEDIUM = 'md',
  SMALL = 'sm'
}

export interface Modal {
  path: string;
  locationState?: object;
}

export type ModalState = Modal[];

const reducers = {
  enqueue: (state: ModalState, payload: Modal[] | Modal): ModalState => [
    ...state,
    ...(isArray(payload) ? payload : [payload])
  ],
  unshift: (state: ModalState, payload: Modal[] | Modal): ModalState =>
    isArray(payload) ? [...(payload as Modal[]), ...state] : [payload as Modal, ...state],
  unique: (state: ModalState, payload: Modal): ModalState =>
    !state.find(({ path }) => path === payload.path) ? [...state, payload] : state,
  unshiftUnique: (state: ModalState, payload: Modal): ModalState =>
    !state.find(({ path }) => path === payload.path) ? [payload, ...state] : state,
  replace: (state: ModalState, payload: Modal[]) => [...payload, ...state.slice(1)],
  close: (state: ModalState, payload?: Modal['path']): ModalState =>
    state.length && (!payload || state[0].path.startsWith(payload)) ? state.slice(1) : state,
  clear: (): ModalState => []
};

const selectors = (slice: Slicer<ModalState>) => ({
  getCurrent() {
    return slice<Modal | undefined>((state) => state[0]);
  }
});

const modal: Model<ModalState, typeof reducers, void, void, typeof selectors> = {
  state: [],
  reducers,
  selectors
};

export default modal;
